import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import { SVGICON } from "../../constant/theme";
import { navtoggle } from "../../../store/actions/AuthActions";

const NavHader = () => {
  const { openMenuToggle } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const sideMenu = useSelector((state) => state.sideMenu);

  const handleToggle = () => {
    openMenuToggle();
    dispatch(navtoggle());
  };

  return (
    <div className="nav-header">
      <Link to="/dashboard" className="brand-logo">
        <img
          src="/pragathilogo0.13.png"
          alt="PRAGATHI"
          className="brand-title-img"
        />
      </Link>

      <div className="nav-control" onClick={handleToggle}>
        <div className={`hamburger ${sideMenu ? "is-active" : ""}`}>
          <span className="line">{SVGICON.NavHeaderIcon}</span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;